import {useAuthAxios} from 'hooks/api/useAuthAxios'

export const useDelete = () => {
  const authAxios = useAuthAxios()
  return async (egovProcedureId: string) => {
    const path = `/api/egov_procedure_statuses/${egovProcedureId}`
    return await authAxios.delete(path)
  }
}
